import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonDrawer from "../../drawer/CommonDrawer";
import {
  cancel,
  confirmRemoval,
  removalConfirmationMsg,
  remove,
} from "../../messages";
import { deleteIcon } from "../../images";
import Text from "../../text/Text";
import Button from "../../button/Button";

function RemoveAppConfirmationModal({
  isConfirmModalOpen,
  setIsConfirmModalOpen,
  isDeleteLoader,
  handleAction,
}) {
  return (
    <CommonDrawer
      anchor="bottom"
      open={isConfirmModalOpen}
      onClose={() => setIsConfirmModalOpen(false)}
    >
      <Box padding="15px 20px">
        <CloseIcon
          className="my-app-close-icon"
          sx={{ float: "right" }}
          onClick={() => setIsConfirmModalOpen(false)}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          clear="both"
          gap="10px"
        >
          <Box className="drawer-header flex-between"></Box>
          <img src={deleteIcon} alt="delete" />
          <Text size={20} font="bold" className="error-text">
            {confirmRemoval}
          </Text>
          <Text size={14} font="regular" className="grey-text" align="center">
            {removalConfirmationMsg}
          </Text>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        gap="10px"
        width="100%"
        padding="20px 27px"
        boxSizing="border-box"
        borderTop="1px solid #eaebef"
      >
        <Button
          variant="outlined"
          label={cancel}
          color="primary"
          fullWidth
          onClick={() => setIsConfirmModalOpen(false)}
        />
        <Button
          variant="contained"
          label={remove}
          color="error"
          fullWidth
          onClick={handleAction}
          loading={isDeleteLoader}
        />
      </Box>
    </CommonDrawer>
  );
}

export default RemoveAppConfirmationModal;
